export const version = '3.5.1';
export const navbarBreakPoint = 'xl'; // Vertical navbar breakpoint
export const topNavbarBreakpoint = 'lg';
export const settings = {
  isFluid: true,
  isRTL: false,
  isDark: false,
  navbarPosition: 'vertical',
  showBurgerMenu: false, // controls showing vertical nav on mobile
  currency: '$',
  isNavbarVerticalCollapsed: true, // toggle vertical navbar collapse
  navbarStyle: 'card'
};

export default { version, navbarBreakPoint, topNavbarBreakpoint, settings };
